import { render, staticRenderFns } from "./MatchTab.vue?vue&type=template&id=2db023f2&scoped=true&"
import script from "./MatchTab.vue?vue&type=script&lang=ts&"
export * from "./MatchTab.vue?vue&type=script&lang=ts&"
import style0 from "./MatchTab.vue?vue&type=style&index=0&id=2db023f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db023f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
